import React from 'react';
import { connect } from 'react-redux';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment-timezone';

function TimeUtil ({ children, userProfile }) {
    const timezone = userProfile.customerTimeZone || '';

    moment.tz.setDefault(timezone);

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            {children}
        </MuiPickersUtilsProvider>
    );
}

const mapStateToProps = state => ({
    userProfile: state.user.profile
});

export default connect(mapStateToProps)(TimeUtil);